import React from "react";
import PropTypes from "prop-types";

import CollapsableTitle from "./CollapsableTitle";
import CollapsableContent from "./CollapsableContent";

const Collapsable = ({
	id,
	title,
	content,
	className,
	onClick,
	isCollapsedByDefault = true
}) => {
	return (
		<li
			id={id}
			className={`block-collapsable ${className}`}
			style={isCollapsedByDefault ? { maxHeight: "0px" } : ""}
			onClick={onClick}
		>
			<CollapsableTitle>{title}</CollapsableTitle>
			{content && <CollapsableContent>{content}</CollapsableContent>}
		</li>
	);
};

Collapsable.propTypes = {
	id: PropTypes.string,
	title: PropTypes.node,
	content: PropTypes.node,
	isCollapsedByDefault: PropTypes.bool,
	className: PropTypes.string,
	onClick: PropTypes.func
};

export default Collapsable;
